enum SecondScreenOperation {
    FilterEncounterUnapprovedNotes,
    FilterEncounterMyNotes,
    FilterEncounterClinicVisitNotes,
    ConfigureNotes
}

export { SecondScreenOperation };
